<template>
  <div class="event-item-footer">
    <div class="event-item-icon-component no-margin-left-right row">
      <div class="icon-footer icon-draft"></div>
      <div class="event-item-icon-amount">{{client.drafts}}</div>
    </div>
    <div class="event-item-icon-component row">
      <div class="icon-footer icon-submitted"></div>
      <div class="event-item-icon-amount"> {{client.archived}}</div>
    </div>
    <div class="event-item-icon-component row">
      <div class="icon-footer icon-approved"></div>
      <div class="event-item-icon-amount">{{client.approved}}</div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/home';
  export default {
    name: 'event-item-footer',
    props: {
      client: Object
    }
  }
</script>


// WEBPACK FOOTER //
// ClientCardFooter.vue?05fba0c5